// Draw Routes Campaign Types

export interface LatLng {
    lat: number;
    lng: number;
}

export interface RouteWaypoint {
    latitude: number;
    longitude: number;
    order: number;
}

export interface DrawRoutesConfig {
    startingPoint: {
        latitude: number;
        longitude: number;
        address: string;
        placeId?: string;
    };
    waypoints: RouteWaypoint[];           // User-clicked points
    snappedPath: LatLng[];                // Road-snapped coordinates
    totalDistanceMeters?: number;
    totalDistanceText?: string;           // e.g., "2.4 km"
    encodedPolyline?: string;             // Compact storage
    isValidated?: boolean;
    validatedAt?: string;
}

// A trail comes from either the viewer (the screen playing the ad, preferred) or the driver app
// (fallback for runs the viewer never reported). Only lat/lng/timestamp are guaranteed on both:
// viewer heartbeats carry no accuracy or altitude.
export interface TrackPoint {
    latitude: number;
    longitude: number;
    accuracy: number | null;
    speed: number | null;
    bearing: number | null;
    altitude: number | null;
    timestamp: number;
}

export interface DriverRun {
    runId: number;
    trackPoints: TrackPoint[];
}

export interface Driver {
    runs: DriverRun[];
}

// Default starting point (San Diego)
export const DEFAULT_STARTING_POINT = {
    latitude: 32.7157,
    longitude: -117.1611,
    address: ''
};

// Road-level zoom for drawing routes
export const ROUTE_DRAWING_ZOOM = 17;

// Waypoint limits
export const MIN_WAYPOINTS = 2;
export const MAX_WAYPOINTS = 25;
